import { render, staticRenderFns } from "./LoadingComponent.vue?vue&type=template&id=11a0ca2b&scoped=true"
import script from "./LoadingComponent.vue?vue&type=script&lang=ts"
export * from "./LoadingComponent.vue?vue&type=script&lang=ts"
import style0 from "./LoadingComponent.vue?vue&type=style&index=0&id=11a0ca2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a0ca2b",
  null
  
)

export default component.exports